import { render, staticRenderFns } from "./EDrawerMotivoAula.vue?vue&type=template&id=4742bcb6&scoped=true"
import script from "./EDrawerMotivoAula.vue?vue&type=script&lang=js"
export * from "./EDrawerMotivoAula.vue?vue&type=script&lang=js"
import style0 from "./EDrawerMotivoAula.vue?vue&type=style&index=0&id=4742bcb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4742bcb6",
  null
  
)

export default component.exports